import React from 'react';
import PropTypes from 'prop-types';
import FarmView from '../FarmView';
import CropView from '../CropView';

const changeSumaryFFTDefaultPropMassiveChangeSummary = {};
const ChangeSumaryFFT = ({
  massiveChangeSummary = changeSumaryFFTDefaultPropMassiveChangeSummary,
  viewBy
}) => {
  // Held to the panel's width: as a bare flex item it grew to its content,
  // pushing the list past the panel's right padding.
  return (
    <div className="w-full min-w-0">
      {viewBy === 'farm' ? (
        <FarmView massiveChangeSummary={massiveChangeSummary} />
      ) : (
        <CropView massiveChangeSummary={massiveChangeSummary} />
      )}
    </div>
  );
};

ChangeSumaryFFT.propTypes = {
  massiveChangeSummary: PropTypes.shape(),
  viewBy: PropTypes.string.isRequired
};

export default ChangeSumaryFFT;
